<template>
    <div class="d-flex align-start flex-column">
      <div class="mb-2">
        {{ label }}
      </div>
      <Vue3PersianDatetimePicker
      class="w-100"
      clearable
      :locale="locale"
      simple
      :type="type"
      :display-format="display_format"
      :format="format"
      v-model="innerValue"/>
       <!-- <DatePicker 
          v-if="!reBuild"
          :modal="true"
          :auto-submit="false"
          :locale="locale"
          :label="label"
          label-id="label"
          v-model="innerValue"
          :column="1"
          mode="single"
        /> -->
    </div>
  </template>
  
<script>
  //import DatePicker from "@alireza-ab/vue3-persian-datepicker";
  import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'

export default {
  name: "DateComponent",
  components:{
    //DatePicker,
    Vue3PersianDatetimePicker,
  },

  props: {
    modelValue: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "date"
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    display_format: {
      type: String,
      default: "jYYYY-jMM-jDD"
    },
    type: {
      type: String,
      default: "date"
    },
    locale: {
      type: String,
      default: "en"
    }
  },

  data() {
    return {
      innerValue: this.modelValue,
      reBuild:false,
    }
  },
  methods:{
    clear(){
      this.innerValue = '';
      this.reBuild = true;
      setTimeout(() => {
        this.reBuild = false;
      }, 10); 
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>

<style>
.vpd-input-group input{
  padding: 6px 11px !important;
    border-radius: 7px;
    text-align: center;
    color: black;
}
.vpd-input-group .vpd-clear-btn{
  line-height: 42px !important;
}
</style>